import { render, staticRenderFns } from "./TheLessonAdd.vue?vue&type=template&id=994d5bd4&scoped=true&"
import script from "./TheLessonAdd.vue?vue&type=script&lang=js&"
export * from "./TheLessonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d5bd4",
  null
  
)

export default component.exports